import { ApplicationStatuses } from '@/enums/ApplicationStatuses'
import { UserRoles } from '@/enums/UserRoles'

export default {
  methods: {
    canCheckApplication () {
      const application = this.form.application

      if (this.canAgentApproval()) {
        return true
      }

      if (this.canSubdivisionApproveAgentApplication()) {
        return true
      }

      return ((['notactive', ApplicationStatuses.BEGIN].includes(application.status) &&
          [UserRoles.SUBDIVISION, UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(this.user.role) &&
          this.canCheck(application.user_id)) ||
        ([ApplicationStatuses.SUBDIVISION_YES, ApplicationStatuses.SB_YES, ApplicationStatuses.SB_BEGIN, ApplicationStatuses.FSB_BEGIN, ApplicationStatuses.SB_NO, ApplicationStatuses.FSB_NO, ApplicationStatuses.KTSP, ApplicationStatuses.FSB_YES].includes(application.status) &&
          [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(this.user.role))
      )
    },

    isAgentOwner () {
      return Boolean(
        this.user.role === UserRoles.AGENT &&
        this.form.application.agent_organization_id === this.user.organization_id
      )
    },

    canAgentApproval () {
      return Boolean(
        [ApplicationStatuses.BEGIN, 'notactive'].includes(this.form.application.status) &&
          this.isAgentOwner()
      )
    },

    canSubdivisionApproveAgentApplication () {
      return Boolean(
        [UserRoles.SUBDIVISION].includes(this.user.role) &&
        [ApplicationStatuses.AGENT_YES].includes(this.form.application)
      )
    },

    canCheck (userId) {
      const subdivUsers = this.db.terminal_subdivisions_user
      const subdivisionId = this.form.application.subdivision_id
      let can = false

      subdivUsers.forEach((val) => {
        if (Number(val.user_id) === Number(userId)) {
          can = false
        } else if (Number(val.subdivision_id) === Number(subdivisionId)) {
          can = true
        }
      })

      return can
    }
  }
}
